<template>
  <div id="app">
    <Header v-show="!hiddenHeaderRoute.includes($route.name)"></Header>
    <Header2 v-show="!hiddenHeaderRoute2.includes($route.name)"></Header2>
    <total v-if="$route.name != 'joumal'"></total>
    <router-view />
    <!-- 占位box -->
    <!-- <div class="blank-box"><br/></div> -->
    <Footer v-show="!hiddenfooter.includes($route.name)"></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Header2 from "@/components/Header2";
import Footer from "@/components/Footer";
import Total from "@/components/total";
export default {
  name: "App",
  data() {
    return {
      hiddenHeaderRoute: ["home"],
      hiddenHeaderRoute2: ["ranking", "findmore", "recommend", "map"],
      hiddenfooter: ["home", "map"],
    };
  },
  components: {
    Header,
    Footer,
    Total,
    Header2,
  },
  mounted() {},
};
</script>

<style>
@import "../static/reset.css";
</style>
<style lang="less">
@import "./main.less";
#app {
  background: #f8fbff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue